import { render } from "./UserHead.vue?vue&type=template&id=9ba0beec&scoped=true&ts=true"
import script from "./UserHead.vue?vue&type=script&lang=ts"
export * from "./UserHead.vue?vue&type=script&lang=ts"

import "./UserHead.vue?vue&type=style&index=0&id=9ba0beec&lang=scss"
import "./UserHead.vue?vue&type=style&index=1&id=9ba0beec&scoped=true&lang=css"
import "./UserHead.vue?vue&type=style&index=2&id=9ba0beec&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba0beec"]])

export default __exports__